import React from 'react';
import { CTAButton } from '../CTAButton';
import { MOCKUP_IMAGE } from '../../data/links';
export function FinalCTA() {
  return <section className="bg-navy px-5 py-14 text-white md:py-20" data-id="element-147" data-mp="5cqy0f7hu19q">
      <div className="mx-auto max-w-3xl text-center" data-id="element-148" data-mp="3mujwppoksmvb">
        <h2 className="text-[26px] font-extrabold leading-[1.18] md:text-4xl" data-id="element-149" data-mp="3mrnxly0zrs5a">
          Stop Letting Scattered Observations Complicate Your Documentation Workflow.
        </h2>
        <p className="mt-4 text-base leading-relaxed text-white/80 md:text-lg" data-id="element-150" data-mp="3dris5tfcz3tr">
          Postoperative wound monitoring requires attention to detail, consistent records, and clear professional
          communication. Your documentation tools should support those responsibilities.
        </p>
        <p className="mt-3 text-base leading-relaxed text-white/80 md:text-lg" data-id="element-151" data-mp="38uivua8b9ffu">
          With the <strong className="text-white" data-id="element-152" data-mp="124ujti7fnb59">POST-OP WOUND ASSESSMENT PATHWAY™</strong>, you get a structured system
          for organizing assessments, recording findings, preparing clinical handoffs, and tracking follow-up information.
        </p>

        <img src={MOCKUP_IMAGE} alt="" className="mx-auto mt-8 w-full max-w-lg" data-id="element-153" data-mp="l9k2f2ohj1r0" />

        <p className="mt-6 text-lg font-extrabold text-gold md:text-xl" data-id="element-154" data-mp="l7fzamyeu6rs">
          6 Practical Volumes. 5 Actionable Bonuses. One Organized Workflow.
        </p>
        <p className="mt-2 text-sm font-semibold text-white/80" data-id="element-155" data-mp="v0eqmclakbf3">Get complete access for just $27</p>

        <div className="mt-8" data-id="element-156" data-mp="7asu5wwb0aas">
          <CTAButton label="Get My System — $27" sublabel="Yes! I want my postoperative wound assessment system" data-id="element-157" data-mp="7bvhxvybxwmh" />
        </div>
        <p className="mt-4 text-xs font-semibold text-white/70" data-id="element-158" data-mp="ga7h4md9i2qj">
          Instant Digital Access · Secure Checkout · 7-Day Guarantee
        </p>
      </div>
    </section>;
}